import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import swal from 'sweetalert';
import { Button} from 'react-bootstrap';
import SvgIcon from 'react-icons-kit';
import RaisedButton from 'material-ui/RaisedButton';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import {download} from 'react-icons-kit/fa/download';
import {ic_local_offer} from 'react-icons-kit/md/ic_local_offer';
import {List} from 'material-ui/List';
import {droplet} from 'react-icons-kit/icomoon/droplet';
import ModalGrupoRH from '../../offers/components/ModalGrupoRH';
import PatientData from '../../offers/components/PatientData';
import AddressData from '../../offers/components/AddressData';
import PhonesData from '../../offers/components/PhonesData';
import {search} from 'react-icons-kit/icomoon/search';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import ModalPersonSearch from '../../generics/modal_person_search';
import $ from 'jquery';

const {htmlToText} = require('html-to-text');

var Config = require('../../../config');

const genders = ["HOMBRE","MUJER"];

class BagEntries extends Component{
	constructor(props){
		super(props);

		this.validateInput = this.validateInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.selectFieldHandle = this.selectFieldHandle.bind(this);
		this.extractionTypeSelected = this.extractionTypeSelected.bind(this);
		this.donationTypeSelected = this.donationTypeSelected.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
		this.onClickDownload = this.onClickDownload.bind(this);
		this.onVolumeChange = this.onVolumeChange.bind(this);
		this.doubleCheck = this.doubleCheck.bind(this);
		this.onHourChange = this.onHourChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onLabelClick = this.onLabelClick.bind(this);
		this.updateGroupTestData = this.updateGroupTestData.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.setInfoPatient = this.setInfoPatient.bind(this);
		this.clearPatientSearch = this.clearPatientSearch.bind(this);
		this.getServerDate = this.getServerDate.bind(this);
		this.clearForm = this.clearForm.bind(this);
		this.keyPressed = this.keyPressed.bind(this);
		
		this.updateStateDonor = this.updateStateDonor.bind(this);
		this.availableEdit = this.availableEdit.bind(this);
		this.person_search = this.person_search.bind(this);
		this.calcularEdadPaciente = this.calcularEdadPaciente.bind(this);

		this.state = {
			timestamp:'',
			timestamp_date:"",
			timestamp_hour:"",
			day_sesion_donation:'',
			don_usr_clc:"",
			donation_type_id:"",
			donation_type_extraction_id:"",
			convoke_places_id:"",
			names:"",
			lastname1:"",
			lastname2:"",
			birthday:"",
			age:"",
			sex:"",
			extraction_types:[],
	    	donation_types:[],
	    	day_sessions:[],
	    	convoke_places:[],
			
	    	medical_staff_id:"",
			staff:[],

			show_group_rh:false,
			start_hour:"",
			end_hour:"",
			cycle_number:"",
			volume_anticoagulant:"",
			lote_anticuagulant:"",
			platelet_performance:"",
			equivalent_units:"",
			equivalent_units_double:"",
			colorBtnHistory:"green",

			show_num_donation:false,
			donation_number:"",

			hideFieldsAph : false,

			extraction_time:"",

			disabled_element:true,

			double:false,

			//formar variable
			donation: {
				equipment_id:"",
				tube : "0",
				arm : "",
				bag_flag  : "1",
				blood_bags_id:""
			},

			volume: "",
			apheresis_kits_id : "",

			unit:[],

			lote_number_locallote_number:"",
			local_number:"",

			equipments: [], 
			apheresis: [],
			component_kit:[],
			arms: [],
			blood_bags: [],

			isLoading: false,
			national_centers:[],

			biometrics:[],
			id_offer:"",
			id_person:"",
			id_donation:"",
			donor_id:"",
			type_extraction_name:"",
			disableBar:true,
			group_test_id:0,
			group_rh:"",
			blood_group:[],
			show_patient_data:false,
			patient_name:"",
			patient_lastname1:"",
			relationship:"",
			national_center_id:"",
			facility_section_id:"",
			person_patient_id:"",
			patient_id:"",
			local_number:"",
			social_number:"",
			preview_print:{},
			relationship:"",
			national_center_id:"",
			national_name:"",

			street:"",
			postal_code:"",
			mpio:"",
			state:"",
			address_id:"",

			phonesAdded:[],

			require_phone:false,
			optionsDonor: [],
			documents:[],
			document_type:"DOCUMENT_INE",
			required_fields:[],
			patient_sex:"",
			patient_birthday:""
		}
	}

	componentDidMount(){
		$(document).on('blur', '.input-date', (e)=>{
			var date = moment(e.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
			
			if(e.target.value !== ""){
				if(date === 'Invalid date' || date === 'Fecha inválida'){
					swal('Error', 'Debes ingresar un valor válido. El campo está incompleto o contiene una fecha no válida.', 'error');

					$('#'+e.target.id).addClass('error');

					setTimeout(()=>{
						$('#'+e.target.id).val('');
						e.target.value = "";
						
						this.dateHandleChange(e);
					}, 3500)
				}else{
					$('#'+e.target.id).removeClass('error');
				}
			}else{
				$('#'+e.target.id).removeClass('error');
			}

				
		});


		this.getServerDate();


		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}

		fetch(Config.default.apiGateway.URL+'form_fields_required/?key=external_entry',{
			method: 'get',
		    headers: new Headers({
		       'Authorization'	: 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept'			: 'application/json',
		       'Content-Type'	: 'application/json',
		    })
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				response.fields_required.map((res)=>{
					this.setState({required_fields: [...this.state.required_fields, res]});
				})
			}
		});

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})

		fetch(Config.default.apiGateway.URL+'donation_type_extraction',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', "Tipos Extracción: "+result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      extraction_types: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'work_sessions/'+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      day_sessions: response
		    });
		})

		//Consultar el turno correspondiente y mostrarlo
		fetch(Config.default.apiGateway.URL+'work_sessions/?option=&health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				this.setState({day_sesion_donation:response.id});
			}else{
				swal('¡Atención!', "No existen sesiones de trabajo configuradas para su hospital", 'warning');
			}
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({
					blood_group: response
				});
			}

		});
		fetch(Config.default.apiGateway.URL+'lookups?type=document_type&notrender=0',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      documents: response
		    });
		})

		this.getConvokePlace();
		this.getBloodBags();
		this.getApheresisKit();
		
		if(this.props.match.params.id !== undefined){
			var id = this.props.match.params.id;
			this.props.waiting.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'donations/get_external_donation?id='+id,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
			    })
			}).then(res => {
				this.props.waiting.handleClose();
		    	if(res.ok){
		          	return res.json();
		        }else{
		          	res.text().then(function(result) {
		            	swal('¡Error', result, 'error');
		          	});
	        	}
	        	
	        }).then(response => {
				if(response !== undefined){
					response.unit.map((u, i)=>{
						u.unit = i;
					});

					this.getDonationType(response.offers.donation_type_extraction_id);

					if(response.donation.timestamp_date !== null){
						this.setState({
							timestamp: (moment(response.donation.timestamp_date, 'YYYY-MM-DD').format('DD/MM/YYYY')+' '+
										moment(response.donation.timestamp_hour, 'HH:mm').format('HH:mm')),
						})
					}

					this.setState({
						day_sesion_donation: response.offers.work_session_id,
						convoke_places_id: response.offers.convoke_places_id,
						donation_type_extraction_id: response.offers.donation_type_extraction_id,
						donation_type_id: response.offers.donation_type_id,
						names: response.donor_person.names,
						lastname1: response.donor_person.lastname1,
						lastname2: response.donor_person.lastname2,
						birthday: moment(response.donor_person.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY'),
						age: response.offers.donor_age,
						sex: response.donor_person.sex,

						show_num_donation: true,
						donation_number: response.donation.donation_number,
						timestamp_date: response.donation.timestamp_date !== null ? moment(response.donation.timestamp_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : "",
						timestamp_hour: response.donation.timestamp_hour !== null ? moment(response.donation.timestamp_hour, 'HH:mm').format('HH:mm') : "",
						local_number: response.donation.local_number,

						donation: response.donation,
						donation_id: response.donation.id,
						offers_id: response.offers.id,
						extraction_time: response.donation.extraction_time !== null ? response.donation.extraction_time : "",
						volume: response.unit.length > 0 ? response.unit[0].volume : response.donation.volume,
						group_rh: response.group_test !== null ? response.group_test.group+' '+response.group_test.RH : "",

						apheresis_kits_id: response.donation.apheresis_kits_id,
						unit: response.unit.length > 0 ? response.unit : [],

						disabled_element: response.edit ? false : true,
						disableBar: false,
						id_offer: response.offers.id,
						donor_id: response.donor.id,
						id_person: response.donor_person.id,

						street:response.address.street,
						postal_code:response.address.postal_code,
						address_id:response.address.id,

						phonesAdded:response.phones,
					});

					this.getBiometrict(response.donor_person.sex);

					if(response.document !== null){
						this.setState({
							document_type:response.document.document_type,
							document_number:response.document.document_number
						});
					}

					this.getServerDate();

					this.address.getMpios(response.address.estado, response.address.municipio)

					if(response.patient !== null){
						this.setState({
							show_patient_data: true,
							checkEditDataPatient:true,
							//id_person: response.patient_person.id,
							relationship:response.offers.patient_relationship,
							national_center_id:response.offers.national_center_id,
							national_name:response.offers.patient_section_name
						});
						var item = {
							patient: response.patient,
							person: response.patient_person,
							patient_sex:response.sex
						};

						setTimeout(()=>{
							this.setInfoPatient(item);
						}, 500);
						
					}

					this.state.apheresis.map(function(a){
						if(a.apheresis_kit.id === response.donation.apheresis_kits_id){
							this.setState({
								component_kit:a.asigned_components.components,
								asigned_kit: a.asigned_components.asigned,
							});
						}
					}.bind(this));

					setTimeout(function(){
						if(response.unit.length > 0 && parseInt(this.state.donation_type_extraction_id) !== 1){

							var units = [];
							response.unit.map((u, i)=>{
								if(response.donation.volume === null){
									var volume = u.volume;
								}else{
									volume = response.donation.volume;
								}				

								if(units.length === 0){
									units.push([{
										unit:1,
										donation_id:u.donation_id,
										id:u.id,
										blood_component_id:u.blood_component_id, 
										volume:parseInt(volume),
										current_unit:u.current_unit,
										unit_number: response.donation.donation_number,
										component_number:u.component_number,
										caducidad:u.caducidad
									}])
								}else{
									
									var bool = units.some(function(arr) {
									  return arr.every(function(prop, index) {
									    return u.blood_component_id === prop.blood_component_id
									  })
									});

									if(bool){
										units.some(function(arr) {
										  	return arr.every(function(prop, index) {
										    	return u.blood_component_id === prop.blood_component_id ?
										    		arr.push({
														unit:prop.unit+1,
														donation_id:u.donation_id,
														id:u.id,
														blood_component_id:u.blood_component_id, 
														volume:parseInt(volume),
														current_unit:u.current_unit,
														unit_number: response.donation.donation_number,
														component_number:u.component_number,
														caducidad:u.caducidad
													})
										    	: null
										  	})
										})
									}else{
										units.push([{
											unit:1,
											donation_id:u.donation_id,
											id:u.id,
											blood_component_id:u.blood_component_id, 
											volume:parseInt(volume),
											current_unit:u.current_unit,
											unit_number: response.donation.donation_number,
											component_number:u.component_number,
											caducidad:u.caducidad
										}])
									}
								}
							})

							var double = false;
							units.map((item)=>{
								if(item.length === 1){
									item.push({
										unit:item[0].unit+1,
										donation_id:item[0].donation_id,
										id:item[0].id,
										blood_component_id:item[0].blood_component_id, 
										volume:"",
										current_unit:item[0].current_unit,
										unit_number: item[0].donation_number,
										component_number:item[0].component_number,
										caducidad:item[0].caducidad
									})
								}else{
									double = true;
								}
							})

							this.setState({
								unit: units,
								double:double
							})
						}




							
					}.bind(this), 500);

					setTimeout(()=>{
						response.biometrics.map((b)=>{
							if(document.getElementById('biometric_'+b.biometrics_id) !== null){
								document.getElementById('biometric_'+b.biometrics_id).value = b.value
							}
						});

						response.vital_signs.map((vs)=>{
							if(document.getElementById('vital_sign_'+vs.biometrics_id) !== null){
								document.getElementById('vital_sign_'+vs.biometrics_id).value = vs.value
							}
						})
					}, 500)
						
				}

			})
		}else{
			this.getBiometrict("");	
		}
	}

	getServerDate(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');

			if(this.state.timestamp_date === 'Invalid date' || this.state.timestamp_date === "" &&
			this.state.timestamp_hour === 'Invalid date' || this.state.timestamp_hour === ""){
				this.state.timestamp = aux[0]+' '+this.getHourFormat(aux[1]);
			}
			

			if(this.state.timestamp_date === 'Invalid date' || this.state.timestamp_date === ""){
				this.state.timestamp_date = aux[0];
			}
			
			if(this.state.timestamp_hour === 'Invalid date' || this.state.timestamp_hour === ""){
				this.state.timestamp_hour = this.getHourFormat(aux[1]);
			}
			
		})
	}

	getConvokePlace(){
		fetch(Config.default.apiGateway.URL+'convoke_places?option=active',{ 	
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			if(response !== undefined){
				this.setState({convoke_places: response});
			}
			
		})
	}

	getApheresisKit(){
		//apheresis_kits
		fetch(Config.default.apiGateway.URL+'apheresis_kits',{
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json', 
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({
				apheresis: response
			})
		})
	}

	getBloodBags(){
		//blood_bags
		fetch(Config.default.apiGateway.URL+'blood_bags/by_hf/'+sessionStorage.getItem('health_facilities_id'), {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'	 	: 'application/json',
				'Content-Type' 	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({
				blood_bags: response
			})
		})
	}

	//get biometricos
	getBiometrict (sex){
		fetch(Config.default.apiGateway.URL+'biometrics?option=biometrics_for_entry&sex='+sex,{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	    .then(response => response.json())
	    .then(response => {
	      for (var i = 0; i < response.length; i++) {
	      	response[i].offer_id = this.state.offer_id;
	      };
	      this.setState({biometrics: response});
	      setTimeout(function() { //Start the timer
		  	for(var j =0;j<response.length;j++){
		  		if(document.getElementById('biometric_'+response[j].id) !== null){
		  			document.getElementById('biometric_'+response[j].id).required = response[j].required;
		  		}
		  		
		  	}
		  }.bind(this), 500)
	      
	    })
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	validString(value){
		return new RegExp("^[a-zA-Záéíóú´ ./ñÑ]+$").test(value);
	}

	handleChange(e){
		var campo = e.target.name;

		if(campo === 'names' || campo === 'lastname1' || campo === 'lastname2' ||
			campo === 'patient_name' || campo === 'patient_lastname1' || campo === 'patient_lastname2'){
			if(e.target.value === ""){
				this.setState({
			      [e.target.name]: e.target.value
			    });		
			}
			if(this.validString(e.target.value)){
				this.setState({
			      [e.target.name]: e.target.value
			    });		
			}
		}else if(campo === 'extraction_time'){
			if(e.target.value === ""){
				this.setState({[campo] : e.target.value});
			}
			
			if(e.target.value.length < 3){
				if(e.target.value.indexOf('-') === -1){
					this.setState({[campo] : e.target.value});
				}else{
					var value = e.target.value.substring(0, e.target.value.length - 1);
					this.setState({[campo] : value});
				}
			}			
		}else if(campo === 'volume'){
			if(e.target.value === ""){
				this.setState({[campo] : e.target.value});
			}
			
			if(e.target.value.length < 4){
				if(e.target.value.indexOf('-') === -1){
					this.setState({[campo] : e.target.value});
				}else{
					var value = e.target.value.substring(0, e.target.value.length - 1);
					this.setState({[campo] : value});
				}
			}			
		}

		else{
			this.setState({[campo] : e.target.value});
		}

			

		if(campo === 'start_hour' || campo === 'end_hour'){
			this.validateHour(e.target);
		}

		if(campo === 'hour'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		
		}else{
			setTimeout(function(){
				this.showCtrlError(campo);
			}.bind(this), 500)
		}	

		if(e.target.name === 'apheresis_kits_id'){
			var event = e;
			this.state.apheresis.map(function(a){
				
				if(a.apheresis_kit.id === parseInt(event.target.value,10)){
					this.setState({
						component_kit:a.asigned_components.components,
						asigned_kit: a.asigned_components.asigned,
						unit:[]
					});
				}
			}.bind(this));

			setTimeout(function(){
				this.state.component_kit.map(function(c, i){

					var objIndex = this.state.unit.findIndex((obj => obj.blood_component_id === this.state.asigned_kit[i].blood_component_id));
				
					if(objIndex === -1){
						this.setState({
							unit: [...this.state.unit, 
									[{
										unit:1,
										donation_id:this.state.donation_id,
										blood_component_id:this.state.asigned_kit[i].blood_component_id, 
										volume:"", 
										current_unit:true,
										unit_number:this.state.donation_number,
										component_number: "",
										caducidad: this.calculateExpiration(this.state.asigned_kit[i].expiration_days)
								  	},
								  	{
								  		unit:2,
										donation_id:this.state.donation_id,
										blood_component_id:this.state.asigned_kit[i].blood_component_id, 
										volume:"", 
										current_unit:true,
										unit_number:this.state.donation_number,
										component_number: "",
										caducidad: this.calculateExpiration(this.state.asigned_kit[i].expiration_days)
								  	}]
								  ]
						});
					}	
				}.bind(this));
			}.bind(this), 500);
			
			setTimeout(function(){}.bind(this), 500)
		}	
	}

	selectFieldHandle = (id, name, event, index, value) => {
		this.setState({[event.target.name]:event.target.value});
	}

	extractionTypeSelected(e){
		this.setState({
			donation_types:[],
			[e.target.name]:e.target.value
		});

		this.getDonationType(e.target.value);
	}

	getDonationType(id){
		fetch(Config.default.apiGateway.URL+'donation_rules?option=donation_extraction&donation_extraction_id='+id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({ donation_types: response});
			document.getElementById("donation_type_extraction_id").classList.remove("error");
			//Guardar el nombre del tipo de extraccion "SANGRE_TOTAL o AFÉRESIS"
			
			for(var i=0; i < this.state.extraction_types.length;i++){
				if(parseInt(this.state.donation_type_extraction_id,10) === parseInt(this.state.extraction_types[i].donation_type_extraction.id)){
					if(this.props.match.params.id === undefined){
						this.setState({
							//type_extraction_name:this.state.extraction_types[i].donation_type_extraction.donation_type_process,
							volume:this.state.extraction_types[i].donation_type_extraction.volumen_default
						});
					}
					
					this.setState({
						type_extraction_name:this.state.extraction_types[i].donation_type_extraction.donation_type_process,
						//volume:this.state.extraction_types[i].donation_type_extraction.volumen_default
					});
					
				}
			}	
			
					    
		})
	}

	donationTypeSelected(event){
		this.setState({[event.target.name] : event.target.value});
		document.getElementById(event.target.id).classList.remove("error");

		for(var i=0; i < this.state.donation_types.length;i++){
			if(parseInt(this.state.donation_types[i].donation_type.id,10) === parseInt(event.target.value,10)){
				if(this.state.donation_types[i].donation_type.patient_required===1){//La donacion requiere paciente
					this.state.show_patient_data= true;
				}else{
					this.state.show_patient_data= false;
				}
			}
		}
	}

	/*dateHandleChange = (event) => {
		this.setState({
	      [event.target.name]: event.target.value
	    });
		
		var control = document.getElementById(event.target.id);

		if(event.target.value.length === 10 && event.target.value.indexOf('_') === -1 ){
			control.classList.remove('error');
	    	this.calcularEdad(event.target.value, control);
		}else{
			if(event.target.value === ""){
				control.classList.remove('error');
				this.setState({age: ""});
			}else{
				control.classList.add('error');
			}
			
		}
	}*/

	//calcular edad
	calcularEdad(fecha,control){
		var hoy = new Date();
		var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
		console.log(cumpleanos.toString())
	    if(cumpleanos.toString() !== 'Invalid Date'){
		    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
		    var m = hoy.getMonth() - cumpleanos.getMonth();

		    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
		        edad--;
		    }
		    if(edad >= 0 && edad < 110){
				this.setState({age:edad});	
				return true;
		    }else{
		    	this.setState({age:'', birthday:''});	
		    	//swal('Error', 'Fecha de nacimiento incorrecta', 'error');
		    }
		}else{
			control.classList.add('error');
			return false;
			//notify.show('Error, Fecha no válida','error');
		}
	}

	onClickDownload = (e)=>{
		//validar los datos del offer
		if(this.calcularEdad(this.state.birthday, document.getElementById('birthday'))){
			if(this.isValidForm('.input_data_donor')){
				var offer = this.getOffer();
				var person = this.getPerson();
				var address = this.getAddress();

				if(this.state.show_patient_data){
					var patient = this.getPatient();
				}
				
				var error = '';

				var mpio = document.getElementById('MUNICIPIO').value;
				
				if(mpio !== "" && address.municipio === ""){
					error = 'No se seleccionó un municipio del catálogo';
					document.getElementById('MUNICIPIO').classList.add('error');
				}

				e.preventDefault();
				if(error === ''){					
					this.waiting_modal.handleShow("Generando...");
					fetch(Config.default.apiGateway.URL+'donations/entry_donation?health_facilities_id='+sessionStorage.getItem("health_facilities_id"), {
						method: 'POST', // or 'PUT'
						body: JSON.stringify({
							offer:offer,
							person:person, 
							person_patient:patient, 
							address: address
						}), // data can be `string` or {object}!
						headers: new Headers({
							'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
							'Accept': 'application/json',
							'Content-Type': 'application/json;charset=UTF-8'
						})
					}).then(res => {
						this.waiting_modal.handleClose();
						if(res.ok){
							return res.json()
						}else{
							res.text().then((msg)=>{
								swal('Error', msg, 'error');
							})
							console.log('error '+res);
						}
					}).then(response => {
						if(response !== undefined){
							this.setState({
								donation_number: response.donation.donation_number,
								show_num_donation:true,
								donation_id: response.donation.id,
								disabled_element:false,
								id_person:this.state.id_person === "" ? response.person.id : this.state.id_person,
								id_offer:response.offer.id,
								donor_id:response.offer.donor_id,
								disableBar:false,
								patient_id:response.patient_id,
								person_patient_id:response.patient_person_id,
								address_id:response.address_id
							});
							document.getElementById("donation_number").classList.remove('error');
						}
					});
				}else{
					swal('Error', error, 'error');
				}
				
				
			}else {
				swal("¡Error!", "Campos Incompletos", 'error');
			};
		}else{
			document.getElementById('birthday').classList.add('error');
			swal('Error', 'La Fecha de Nacimiento no valida', 'error');
		}
	}

	onHourChange(e){
		this.setState({timestamp_hour:e.target.value});
		this.validateHour(e.target);
	}

	onDateChange(e){
		var fecha = e.target.value;

		var valida = new Date(fecha.split(/\//).reverse().join('/'));
		if(valida.toString() === 'Invalid Date'){
			
			swal('Error', 'Fecha no válida', "error");
			
			this.setState({timestamp_date:""});
			setTimeout(function(){
				this.setState({
					timestamp_date:this.state.original_date
				})
			}.bind(this), 0.001)

		}else{
			this.setState({timestamp_date:fecha});
		}
	}

	//Evento para checkbox
	handleCheck = event => {
		this.setState({ [event.target.name]: event.target.checked});
	}

	//selected element of this.stat.donation
	onElementDonationSelected = (e)=>{
		const donation = this.state.donation;
		donation[e.target.name] = e.target.value;

		this.setState({
			donation: donation
		})

		if(e.target.id !== null){
			var control = document.getElementById(e.target.id);
			if(control !== null){
			  if(control.required && control.className.includes('error')){
				control.classList.remove('error');
			  }else if(control.required && e.target.value===""){
				control.classList.add('error');
			  }
			}
		}
		
		this.hideFields();
	}

	hideFields(){
		if(this.state.donation.bag_flag === '0'){
			const donation = this.state.donation;
			donation.blood_bags_id = "";
			this.setState({
				hideFieldsAph:true,
				apheresis_kits_id:"",
				lote_number:"",
				local_number:"",
				volume_anticoagulant:"",
				lote_anticuagulant:"",
				platelet_performance:"",
				equivalent_units:"",
				duration:"",
				lote_number_local:"",
				donation: donation,
				component_kit:[],
				asigned_kit:[]
			})
		}else{
			this.setState({hideFieldsAph:false});
		}
	}

	onVolumeChange(e){
		var blood_component_id = parseInt(e.target.id.split('_')[1],10);
		var volumen = e.target.value === "" ? "" : parseInt(e.target.value);

		this.state.component_kit.map(function(c, i){
			if(this.state.asigned_kit[i].blood_component_id === blood_component_id){

				this.state.unit[i].map((u, j)=>{
					if("vol_"+u.blood_component_id+'_'+u.unit === e.target.id){
						u.volume = volumen;
					}
				});
				this.forceUpdate();
				
			}
		}.bind(this));
	}

	doubleCheck(e){
		if(e.target.checked){
			this.setState({
				[e.target.name]: this.state.double ? false : true
			})

			this.state.unit.map((item, i)=>{
				return item.length === 1 ?
					item.map((val)=>{
						return item.push({
							unit:val.unit+1,
							donation_id:val.donation_id,
							id:val.id,
							blood_component_id:val.blood_component_id, 
							volume:"",
							current_unit:val.current_unit,
							unit_number: this.state.donation_number,
							component_number:"00",
							caducidad:val.caducidad
						})
					})
				: null
			})

		}else{
			this.setState({
				[e.target.name]: this.state.double ? false : true
			})
		}
	}

	calculateExpiration(dias){
		var date = moment(this.state.timestamp_date, 'DD/MM/YYYY');
		date = date.format('MM-DD-YYYY');

		var fecha = new Date(date);

		fecha.setDate(fecha.getDate() + parseInt(dias));

		var caducidad = fecha.getDate()+'/'+(fecha.getMonth() + 1)+'/'+fecha.getFullYear();
		caducidad = moment(caducidad, 'DD/MM/YYYY');

		return caducidad.format('MM-DD-YYYY');
	}

	calculateValuesBIO(e){
		var control = "";

		this.validateRangeBiometric(e.target.id, e.target.value);
		for (var i = 0; i < this.state.biometrics.length; i++) {
			if (this.state.biometrics[i].data_type === "BIO_D_CALCULATED") {
				var str = (this.state.biometrics[i].formula).split('&');
				var value = this.getTerms(str,'biometric_');
				control = document.getElementById('biometric_'+this.state.biometrics[i].id).value
				if(value !== ""){
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}
					control.value = value;
					control.classList.remove('error');
				}else{
					control.classList.add('error');
					control.value = "";
				}
			};
		};
		if(e.target.id !== null){
			control = document.getElementById(e.target.id);
			if(e.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}else if(control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				control.classList.add('error');
			}
		}
	}

	validateRangeBiometric(id, value){
		for(var i =0; i < this.state.biometrics.length;i++){
			if(id.toString() === 'biometric_'+this.state.biometrics[i].id.toString()){
				if(this.state.biometrics[i].ranges_validation){//Si el biometrico tiene rango de valores
					var aux = parseFloat(value);
					if(this.state.sex === "HOMBRE"){//Valores para hombre
						//Desmarcar el color rojo del control
						if(aux >= this.state.biometrics[i].low_rank_male && aux <= this.state.biometrics[i].high_rank_male){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}else{//Valores para mujer
						//Desmarcar el color rojo del control
						if(aux >= this.state.biometrics[i].low_rank_female && aux <= this.state.biometrics[i].high_rank_female){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}
				}	
			}
		}
	}

	getTerms(term,type){
		var result = "";
		var formula = "";
		for (var i = 0; i < term.length; i++) {
			var id = parseFloat( term[i] );
			if (!isNaN(id)) {
				formula = formula + this.getItemValue(type+id.toString());
			}else {
				formula = formula + term[i];
			};
		};

		try{
			result =  eval(formula);
		}catch(e){
			//swal('Error', 'Verifique todos sus valores antes de calcular','error');
			return "";
		}

		if (!isNaN(result)) {
			return (result).toFixed(2);
		} else{
			return "";
		};
	}

	getItemValue(id){
		return document.getElementById(id).value;
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	if(name === 'component'){
        		this.setState({
		            [name]: values[0]
		        });
        	}else{
        		this.setState({
		            [name]: values[0].id
		        });

		        if (name === 'requested_by') {
		        	this.setState({
						indice:0,
						requestedSelected:values,
				    });
		        };

		        if (name === 'requested_to') {
		        	this.setState({
						indice2:0,
						requested2Selected:values,
				    });

				    document.getElementById('date_form').focus();
		        };
        	}
        	
        }
    }

    validateHour(campo){
		var hour = moment(campo.value, 'h:mm a');

		if(hour.format('H:mm') === "Invalid date" || campo.value.indexOf('-') !== -1){
			document.getElementById(campo.id).classList.add("error");
			document.getElementById(campo.name).style.borderColor = "red";
		}else{
			document.getElementById(campo.name).style.borderColor = "#ccc";
			document.getElementById(campo.id).classList.remove("error");
		}
	}
   
	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			if(form.elements[index + 1].getAttribute("name") === null){
      				if(form.elements[index + 2].getAttribute("disabled") === null){
    					form.elements[index + 3].focus();
    				}else if(form.elements[index + 2].getAttribute("disabled") === ""){
    					form.elements[index + 4].focus();
    				}
      			}else{
	      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
	    				if(form.elements[index + 1].getAttribute("disabled") === null){
	    					form.elements[index + 1].focus();
	    				}else if(form.elements[index + 1].getAttribute("disabled") === ""){
	    					form.elements[index + 3].focus();
	    				}
	    			}
      			}
	      			
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	isValidSearch(){
	    let isFormValid = true;
	    const unit_number = document.getElementById('unit_number');

    	const isInputValid2 = this.showCtrlError(unit_number.name);
      	if (!isInputValid2) {
        	isFormValid = false;
    	}

	    return isFormValid;
	}

	getOffer(){
		var offer = {};
		var date = moment(this.state.timestamp_date, 'DD/MM/YYYY');
		var hour = moment(this.state.timestamp_hour, 'h:mm a');
		offer.timestamp_date = date.format('MM-DD-YYYY');
		offer.timestamp_hour = hour.format('HH:mm');
		offer.donation_type_extraction_id = this.state.donation_type_extraction_id;
		offer.convoke_places_id = this.state.convoke_places_id;
		offer.donor_age = this.state.age;
		offer.work_session_id = this.state.day_sesion_donation;
		offer.donation_type_id = this.state.donation_type_id;
		offer.health_facilities_id = sessionStorage.getItem("health_facilities_id");
		offer.patient_relationship = this.state.relationship;
		offer.national_center_id = this.state.national_center_id;
		offer.patient_section_name = this.state.national_name;

		return offer;
	}

	getPerson(){
		var person = {};
			person.names = this.state.names;
			person.lastname1 = this.state.lastname1;
			person.lastname2 = this.state.lastname2;
			person.birthday = moment(this.state.birthday, 'DD/MM/YYYY');
			person.sex = this.state.sex;

			person.documents = [];
		
			if(this.state.document_type !== ""){
				var obj = {}
				obj.document_type = this.state.document_type;
				obj.document_number = this.state.document_number;
				if(obj.document_number !== null && obj.document_number !==undefined && obj.document_number !== "")
					person.documents.push(obj);
			}
			if(this.state.phonesAdded.length > 0){
				person.phones = this.state.phonesAdded;
			}

			if(this.state.id_person !== ""){
				person.id = this.state.id_person;
			}
			

		return person;
	}

	getObj(){
		var res = "";
		if(parseInt(this.state.donation_type_extraction_id) === 1){
			res = this.getSTObj();
		}else{//AFERESIS
			res = this.getApheresisObj();
		}
		
		return res;
	}

	getSTObj(){
		var donation = {};
		var date = moment(this.state.timestamp_date, 'DD/MM/YYYY');
		var hour = moment(this.state.timestamp_hour, 'h:mm a');
		var duration = this.state.extraction_time;

		donation.id = this.state.donation_id;
		donation.timestamp_date = date.format('MM-DD-YYYY');
		donation.timestamp_hour = this.state.timestamp_hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('HH:mm');
		donation.offers_id = parseInt(this.state.id_offer,10);
		donation.donation_number = this.state.donation_number; //this.state.offer.item.id;
		donation.extraction_time = duration;
		donation.volume = parseInt(this.state.volume,10);
		donation.bag_flag = 1;
		donation.blood_bags_id = parseInt(this.state.donation.blood_bags_id,10);
		donation.local_number = this.state.local_number;

		donation.unit = [];
		this.state.blood_bags.map(function(b){
			if(b.blood_bag.id === parseInt(this.state.donation.blood_bags_id,10)){				

				if(this.state.unit.length > 0){
					donation.unit = this.state.unit;
					donation.unit[0].volume = parseInt(this.state.volume);
				}else{
					donation.unit = [{
						donation_id:this.state.donation_id,
						blood_component_id: b.blood_component_default_id, 
						volume:parseInt(this.state.volume),
						current_unit:true,
						unit_number: this.state.donation_number,
						component_number: "00",
						caducidad: this.calculateExpiration(b.blood_bag.expiration_days),
						health_facilities_id: parseInt(sessionStorage.getItem("health_facilities_id"))
				  	}];
				}

			}
		}.bind(this));

		return donation;
	}

	calculateExpiration(dias){
		var date = moment(this.state.timestamp_date, 'DD/MM/YYYY');
		date = date.format('MM-DD-YYYY');

		var fecha = new Date(date);
		fecha.setDate(fecha.getDate() + parseInt(dias));
		var caducidad = fecha.getDate()+'/'+(fecha.getMonth() + 1)+'/'+fecha.getFullYear();
		caducidad = moment(caducidad, 'DD/MM/YYYY');

		return caducidad.format('MM-DD-YYYY');
	}

	getApheresisObj(){
		var donation = {};
		var date = moment(this.state.timestamp_date, 'DD/MM/YYYY');
		var hour = moment(this.state.timestamp_hour, 'h:mm a');
		var start_hour = this.state.start_hour.indexOf('-') !== -1 ? "" : this.state.start_hour//*/ moment(this.state.start_hour, 'h:mm a');
		var end_hour = this.state.end_hour.indexOf('-') !== -1 ? "" : this.state.end_hour//*/moment(this.state.end_hour, 'h:mm a');
		var unit = [];

		donation.id = this.state.donation_id;
		donation.offers_id = parseInt(this.state.id_offer,10);
		donation.donation_number = this.state.donation_number;//this.state.offer.item.id;
		donation.bag_flag = 1;
		donation.timestamp_date = date.format('MM-DD-YYYY');
		donation.timestamp_hour = this.state.timestamp_hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('HH:mm');
		donation.time_start = start_hour;//.format('H:mm');
		donation.time_end = end_hour;//.format('H:mm');
		donation.apheresis_kits_id = parseInt(this.state.apheresis_kits_id,10);
		donation.local_number = this.state.local_number;
		
		
		if(this.state.double === true){
			if(this.state.equivalent_units_double !== ""){
				donation.equivalent_units_double = parseInt(this.state.equivalent_units_double, 10) 	
			}else{
				donation.equivalent_units_double = null	
			}
		}

		donation.proceced_blood = this.state.processed_blood !== "" ? parseInt(this.state.processed_blood, 10) : null;

		this.state.unit.map((u, i)=>{
			return u.map((item, j)=>{
				if(this.state.double){

					item.component_number = j === 0 ? "A0" : "B0"
					item.health_facilities_id =  parseInt(sessionStorage.getItem("health_facilities_id"));
					if(item.volume !== "")
						unit.push(item)

				}else if(j === 0){
					item.component_number = "00"
					item.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"));
					if(item.volume !== "")
						unit.push(item)
				}
			})			
		})

		donation.unit = unit;
		donation.apheresis_double = this.state.double;
		return donation;
	}

	setInfoPatient(item){
		if(item !== "" && item !== undefined)
		{
			
			this.setState({
				patient_name:item.person.names,
				patient_lastname1:item.person.lastname1,
				patient_lastname2:item.person.lastname2,
				patient_id:item.patient.id,
		    	person_patient_id:item.person.id,
		    	observations:item.patient.observations,
				no_file:item.patient.number,
				social_number:item.person.social_number,
				patient_sex:item.person.sex,
				patient_birthday: item.person.birthday === null ? "" : moment(item.person.birthday).format('DD/MM/YYYY')
			});

			if (item.person.lookup_group !== "" && item.person.lookup_rh !== "") {
				this.setState({
					lookup_group:item.person.lookup_group,
				    lookup_rh:item.person.lookup_rh,
				    rh_group: item.person.lookup_group +(
				    	item.person.lookup_rh === 'POSITIVO' ? ' +' : 
				    	item.person.lookup_rh === 'NEGATIVO' ? ' -' : ''),
				});

				
			}else{
				this.setState({rh_group: "",});
				
				
			}

			//ver si es national center
			if (item.patient.national_center_id) {
				this.setState({hemored:false});

				this.setState({national_center_id:item.patient.national_center_id});

			} else{//hemored
				this.setState({hemored:true});

				if (item.patient.facility_section_id) {
					this.setState({facility_section_id:item.patient.facility_section_id});

					this.offer.searchHealthFacility(item.patient.facility_section_id);
				};
			};

			this.patient.setState({disablePatient:true});
		}
	}

	getPatient(){
		var person = {}

		person.lastname1 = this.state.patient_lastname1;
		person.lastname2 = this.state.patient_lastname2;
		person.names = this.state.patient_name;
		person.person_type='patient';
		person.lookup_group = this.state.lookup_group;
		person.lookup_rh = this.state.lookup_rh;
		person.sex = this.state.patient_sex;
		person.birthday = this.state.patient_birthday;

		if (this.state.person_patient_id !== "") {
			person.id = this.state.person_patient_id;
		};

		person.patient = [];
		var patient_aux = {};
		patient_aux.observations = this.state.observations;
		patient_aux.number = this.state.no_file;
		if (this.state.patient_id !== "") {
			patient_aux.id = this.state.patient_id;
			patient_aux.person_id = person.id;
		};
		person.social_number = this.state.social_number;
		
		person.patient.push(patient_aux);

		return person;
	}

	getAddress(){
		var address = {};

		address.street = this.state.street;
		address.postal_code = this.state.postal_code;
		address.municipio = this.state.mpio;
		address.estado = this.state.state;

		if(this.state.address_id!==""){
			address.id = this.state.address_id;
		}

		return address;
	}

	calcularEdadPaciente(fecha,control){
		var hoy = new Date();
	    var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
	    if(cumpleanos.toString() !== 'Invalid Date'){
		    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
		    var m = hoy.getMonth() - cumpleanos.getMonth();

		    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
		        edad--;
		    }
		    if(edad >= 0 && edad < 110){
		    }else{
		    	this.setState({ patient_birthday: ''});	
		    	swal('Error', 'Fecha de nacimiento del paciente es incorrecta', 'error');
		    }
		}else{
			/*control.classList.add('error');
			notify.show('Error, Fecha no válida','error');*/
		}
	}

	onSave(){
		var valid_date = this.isValidaDate();
		if(this.validBirthdate()){
			document.getElementById('birthday').classList.remove('error');
			if(this.isValidForm('select,input')){
				if (valid_date === ''){
					
					var error = "";
					var object = {};//offer:{},person:{},donation{}
					object.donation = this.getObj();
					object.person = this.getPerson();
					object.person.id = this.state.id_person;
					object.offer = this.getOffer();
					object.offer.id = this.state.id_offer;
					object.offer.donor_id = this.state.donor_id;
					object.offer.group_test = [{
						group: this.state.group_rh.split(' ')[0], 
						RH:this.state.group_rh.split(' ')[1],
						type:'INIT_GROUP'
					}];
					//donor falta
					//Si la donacion requiere a un paciente
					if(this.state.show_patient_data){
						object.person_patient = this.getPatient();
						
						if(object.person_patient.birthday.indexOf('_') !== -1){
							error = 'Edad de paciente no es válida';
							document.getElementById('patient_birthday').classList.add('error');
						}else{
							document.getElementById('patient_birthday').classList.remove('error');
							var birth = moment(object.person_patient.birthday).format('YYYY-MM-DD');

							object.person_patient.birthday = birth;
						}
						
					}

					if(parseInt(this.state.address_id) !== 0 ){
						object.address = this.getAddress();

						var mpio = document.getElementById('MUNICIPIO').value;
				
						if(mpio !== "" && object.address.municipio === ""){
							error = 'No se seleccionó un municipio del catálogo';
							document.getElementById('MUNICIPIO').classList.add('error');
						}
					}
					
					var temp = [];

					for (var i = 0; i < this.state.biometrics.length; i++) {
						var aux = {};
						aux.biometrics_id = this.state.biometrics[i].id;
						aux.offers_id = parseInt(this.state.id_offer,10);
						aux.value = document.getElementById('biometric_'+this.state.biometrics[i].id).value;
						
						if(aux.value !== ""){
							temp.push(aux);
						}
						
					}

					object.biometrics_vs = temp;
					
					
					
					if(error === ""){
						this.waiting_modal.handleShow('Guardando...');
						fetch(Config.default.apiGateway.URL+'donations/update_entry_donation',{
							method: 'POST',
							body: JSON.stringify(object),
							headers: new Headers({
								'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
								'Accept'		: 'application/json',
								'Content-Type'	: 'application/json'
							})
						}).then(res =>{
							this.waiting_modal.handleClose();
	
							if(res.ok){
								return res.json();
							}else{
								res.text().then(function(result){
									swal("Error", result, 'error');
								});
							}
						}).then(response=>{
							if(response !== undefined){
								swal("Correcto", "Registro guardado correctamente.", 'success');
								this.clearForm();
								this.props.history.push('/bag_entries');
							}
						});
					}else{
						notify.show('Error, '+error, 'error');
					}
					
				
				}else{
					notify.show('Error, '+valid_date+' no válida','error');
				}
			}else{
				swal("¡Error!", "Campos Incompletos", 'error');
			}
		}else{
			document.getElementById('birthday').classList.add('error');
			swal('Error', 'La Fecha de Nacimiento no valida', 'error');
		}
	}

	validBirthdate(){
		var aux_date = new Date();
		var hoy = aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2);
		hoy = moment(hoy);
		var birth = this.state.birthday.indexOf('_') !== -1 ? 'Invalid date' : moment(this.state.birthday,'DD-MM-YYYY');
		var date_ok = true;

		
		if(hoy !== 'Invalid date' && birth !== 'Invalid date'){
			if(hoy < birth){
				date_ok = false;
			}
		}else{
			date_ok = false;
		}		

		return date_ok;

	}

	isValidaDate(){
		if(this.state.birthday !== ""){
			var birth = moment(this.state.birthday, 'DD/MM/YYYY').format('MM-DD-YYYY');	
		}
		
		var f_extr = moment(this.state.timestamp_date, 'DD/MM/YYYY').format('MM-DD-YYYY');
		var msg = '';
		if(birth !== undefined){
			if(birth === 'Invalid date'){
				document.getElementById('birthday').classList.add('error');
				msg += 'Fecha de Nacimiento, ';
			}else{
				document.getElementById('birthday').classList.remove('error');
			}
		}

		
		if(this.state.timestamp_date !== ""){
			var limite = moment().subtract('50', 'days');
			
			if(limite > moment(this.state.timestamp_date, 'DD/MM/YYYY') || moment() < moment(this.state.timestamp_date, 'DD/MM/YYYY') ||
				f_extr === 'Fecha invaluda' || f_extr === 'Invalid date'){
				document.getElementById('date_extraction_date').classList.add('error');
				msg += 'Fecha de Extracción, ';
			}else{
				document.getElementById('date_extraction_date').classList.remove('error');
			}

		}else if(this.state.timestamp_date.indexOf('_') !== -1){
			document.getElementById('date_extraction_date').classList.add('error');
			msg += 'Fecha de Extracción, ';
		}else{
			document.getElementById('date_extraction_date').classList.remove('error');
		}
		

		return msg;
	}

	clearForm(){
		var control = {};
		this.clearPatientSearch();
		this.setState({
			disabled_element:true,
			//DATOS DONANTE
			convoke_places_id:"",
			donation_type_extraction_id:"",
			donation_type:"",
			names:"",
			lastname1:"",
			lastname2:"",
			birthday:"",
			age:"",
			sex:"",
			donation_types:[],
			//DATOS DONACION
			donation_number:"",
			apheresis_kits_id:"",
			blood_bags_id:"",
			extraction_time:"",
			volume:"",
			donation: {
				blood_bags_id:""
			},
			group_rh:"",
			disableBar:true,
			local_number:""
		});
		//Limpiar Biometricos y Signos Vitales
		this.state.biometrics.map( (t, index) => {
			control = document.getElementById('biometric_'+t.id.toString());
			control.value = "";
		});

		//Actualizar hora de registro mostrada en el formulario
		this.getServerDate();
	}

	isValidForm(className) {
		const inputs = document.querySelectorAll(className);
	    let isFormValid = true;

	    inputs.forEach(input => {
	    	if(input.id === 'state'){
	    		input.id = 'ESTADO';
	    	}
	    	var index = this.state.required_fields.findIndex(obj => 
	    		obj.field.toUpperCase() === input.id.toUpperCase()
	    	);

	    	if(index !== -1){
	    		//if(this.form.state.required_fields[index].required){
	    			var control = document.getElementById(input.id);

	    			if(control !== null){
	    				if(control.value === ""){
							control.classList.add('error');
				        	isFormValid = false;
				   
						}else{
							if(control.className.includes('error')){
								control.classList.remove('error');
								isFormValid = true;
							}
							
						}
	    			}
	    		//}
	    	}else{
	    		if(input.required){
					  const isInputValid = this.showCtrlError(input.id);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
			  	}
	    	}
	    
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if(refName !== 'phone_number'){
			
			if(this.state[refName] === undefined){
				if(control !== null){
					if(control.required){
						if(control.value === ""){
							control.classList.add('error');
				        	res = false;
				        	
						}else{
							if(control.className.includes('error')){
								control.classList.remove('error');	
							}
							res = true;
						}

					}
			    }
				
			}else{
				
				if (this.state[refName] === "" || this.state[refName] === null) {

					if(control !== null){
						control.classList.add('error');
					}
					res = false;
				} else{
					if(control !== null){
						if(control.required && control.className.includes('error')){
							control.classList.remove('error');
						}
					}
					res = true;
				}
			}
		}else{
			res = true;
		}

		return res;
	}

	getValidationState(name) {
		const length = this.state[name].length;
		let isFormValid = true;
		if (length === 0){
			if(name==='requested_by'){
				this.setState({req_by:'error'});
				isFormValid = false;
			}else{
				this.setState({req_to:'error'});
				isFormValid = false;
			}
		}else{
			if(name==='requested_by'){
				this.setState({req_by:''});
			}else{
				this.setState({req_to:''});
			}
		}

		return isFormValid;
	}

	onCancel(){
		this.props.history.push("/bag_entries");
	}

	/*IMPRIMIR ETIQUETAS*/
	onLabelClick(e){
		e.preventDefault();
		
		fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+'&file_type=label_extraction&extraction_type=',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ninguna etiqueta para el área de registro", 'error');
			}else{
				this.waiting_modal.handleShow('Imprimiendo...');
				
				var obj ={};
				obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
				obj.id = this.state.id_offer;
				obj.file_type = "label_register";
				obj.nEtiqueta = [0];
				fetch(Config.default.apiGateway.URL+'labelsEditor', {
					method : 'post',
					body:JSON.stringify(obj),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				})
				.then(res => {
					this.waiting_modal.handleClose();
					if(res.ok){
						return res.blob();
					}else{
		              res.text().then(function(result) {
		                swal('¡Error!', result, 'error');
		                return;
		              });
		            }
				})
				.then(response => {
					if(response !== undefined){
						if(this.state.preview_print.value === "NO"){
							//PREVIEW
							var fileURL = URL.createObjectURL(response);
							window.open(fileURL);
						}else{
							//PRINTER
							var reader = new FileReader();
							reader.readAsDataURL(response); 
							reader.onloadend = ()=>{
								var base64data = reader.result;  
								var aux = base64data.split(',');
								this.props.socket.send('{"Operacion":"print", "Type":"register", "File": "'+aux[1]+'"}');
							}
						}

			       		this.setState({ show: false});
		       		}
				})
			}
		})
	}

	/*GUARDAR GRUPO & RH*/
	openModalGrupoRH(e){
	    e.preventDefault();
   		this.modal_grupo_rh.handleShow(this.state.donor_id, this.state.id_offer, this.state.group_test_id);
  	}

  	updateGroupTestData(group_test_id,group_rh){
  		this.setState({group_test_id:group_test_id,group_rh:group_rh});
  	}

	clearPatientSearch(){
		this.setState({
			patient_lastname1:"",
			patient_lastname2:"",
			patient_name:"",
			lookup_group:"",
			lookup_rh:"",
			person_patient_id:"",
			observations:"",
			relationship:"",
			facility_section_id:"",
			national_center_id:"",
			national_name:"",
			no_file:"",
		});

		if(this.patient !== undefined && this.patient !== null){
			this.patient.setState({disablePatient:false});
		}
	}
	
	autocompleteHandle = (name,value) => {
		this.setState({[name]:value});
	}

	keyPressed(e){
		if(e.key === '.' || e.key === 'e'){
			e.preventDefault();
		}else if(e.key === 'Enter'){
			this.validateInput(e);
		}else{
			if(e.target.value.length >= 4){
				e.preventDefault();
			}
		}
	}

	addPhoneToList = (phone) => {
		this.setState({ phonesAdded: [...this.state.phonesAdded, phone]});
	}

	removePhoneFromList = (indice) => {
		//if(!this.state.disabled_element){
			var array = [...this.state.phonesAdded];
			array.splice(indice, 1);
			this.setState({phonesAdded: array});
		//}
	}

	_handleSearchDonor = (query) => {
	    this.setState({isLoading: true});
		fetch(Config.default.apiGateway.URL+'donors?search='+query,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
			    })
			})
			.then(response => response.json())
			.then(response => {
				if(response !== null){
					for (var i = 0; i < response.length; i++) {
						
						/* revisar en la base de datos el lastname1 y lastname2 ya que lastname1 contiene el lastname2*/

						if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
							response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '+response[i].names +' '+ response[i].birthday;;
						
						}else{
							response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ response[i].birthday;;
						}


						if(response[i].document !== null){							
							response[i].names +=' '+response[i].document_type_value;
							response[i].names +=' '+response[i].document_number;
							
						}
						response[i].id = response[i].donor_id;
					};
					
					this.setState({
						isLoading: false,
				      	optionsDonor: response
				    });
				}
			})
	}

	updateStateDonor(values) {
	    let value = '';
	    if (values.length > 0) {
	      value = values[0];
	    }
	    this.autocompleteHandle('blockFields',true);
	    this.autocompleteHandle('checkEditData',true);
	    
	   	this.getInfo(value.id);
	}

	autocompleteHandle = (name,value) => {
		this.setState({[name]:value});
	}

	getInfo(id){
		if(id !== "" && id!== undefined){
			return fetch(Config.default.apiGateway.URL+'donors?option=loadDonor&donor_id='+id,{ 
				method: 'get',
				headers: new Headers({
				   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				   'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(response => response.json())
			.then((response) => {
				if(response !== "" && response !== null){
					this.setInfoDonor(response);

					this.props.waiting.handleClose();
				}
			})
		}
	}

	setInfoDonor(item){
		if(item !== "" && item !== null && item!== undefined){
			
			var aux_date = new Date(item.person.birthday);
			var string_date = ("0" + aux_date.getDate()).slice(-2)+'/'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'/'+aux_date.getFullYear();

			this.setState({
				names:item.person.names,
				lastname1:item.person.lastname1,
				lastname2:item.person.lastname2!==null?item.person.lastname2:"",
				sex:item.person.sex,
				//civil_status:item.person.civil_status,
				//scholarship:item.person.scholarship,
				//job_profile:item.person.job_profile,
				//email:item.person.email,
				birthday:string_date,
				street:item.address.street,
				postal_code:item.address.postal_code,
				mpio:item.address.municipio,
				state:item.address.estado,
				id_person:item.person.id,
				address_id:item.address.id,
				donor_id:item.donor.id,
				donor_number:item.donor.donor_number,
				//fmd:item.donor.fingerprint,
				
				/*stats:{
					date_label:item.offer.date_label,
					last_donation_date:item.offer.date,
					donation_type:item.offer.donation_type,
					extraction_type:item.offer.extraction_type,
					total_donations:item.total_num,
					total_last_year:item.total_month,
					lookup_group:item.person.lookup_group,
					lookup_rh:item.person.lookup_rh,
					group_test:item.offer.group_test,
					status_bar_color:item.status_bar_color,
					temporality:item.temporality,
					total_hc:item.total_hc,
					reject_process:item.reject_process,
				}*/
			});
			if(item.document.document !== null){
				this.setState({
					document_type:item.document.document.document_type,
					document_number:item.document.document.document_number
				});
			}
			this.calcularEdad(string_date,'birthday');
			this.address.getMpios(item.address.estado,item.address.municipio);

			this.setState({phonesAdded:[]});

			//this.person_data.setJobProfile(item.person.job_profile);

			
			if(item.phones !== undefined){
				var phones = [];

				for(var i = 0; i < item.phones.length; i++){
					var aux_phone = {};
					aux_phone.type = item.phones[i].type;
					aux_phone.number = item.phones[i].number;
					aux_phone.extension = item.phones[i].extension;

					phones.push(aux_phone);
					
				}

				this.setState({
					phonesAdded: phones
				})
			}

			if(item.alerts.length > 0){
				var alerts = "";
				item.alerts.map((n)=>{
					var note = htmlToText(n);
					alerts += note+'\n'
				})

				swal('Alerta', alerts, 'warning')
			}
				

		}
	}

	availableEdit(e){
		this.autocompleteHandle('blockFields',!e.target.checked);
	}

	person_search(){
		this.modal_person_search.handleShow('Donador','donors');
	}

	dateHandleChange = (event) => {

		if(event.target.id === "birthday"){
			this.setState({ birthday: event.target.value});
			
			var control = document.getElementById(event.target.id);
			if(event.target.value.length === 10){
				control.classList.remove('error');
				this.calcularEdad(event.target.value,control);
			}else{
				control.classList.add('error');
			}
		}else{
			this.setState({ patient_birthday: event.target.value});
			this.calcularEdadPaciente(event.target.value,control);
		}
	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.donors.MAIN')} ->
						Entrada Bolsas Externas
					</h5>
				</div>
				<form noValidate>
					<div className="col-xs-12">
						<fieldset>
							<legend style={{marginBottom:"5px"}}>Datos del Donante</legend>
							<div className="col-xs-12">
								<div className="col-xs-12 col-sm-2" style={{paddingRight:"0px"}}>
									<span className="span-min">{t('content.offers.form.timestamp')}</span>
									<input className="form-control" disabled name="timestamp" value={ this.state.timestamp } 
									onChange={ this.handleChange } />
						 		</div>

						 		<div className="col-xs-12 col-sm-2">
						        	<span className="span-min">{t('content.offers.form.day_session')}</span>
									<select className="form-control" disabled value={ this.state.day_sesion_donation } 
							        	onChange={ this.handleChange } 
						              	name="day_sesion_donation" id="day_sesion_donation">
						                {
						                this.state.day_sessions.map(function(t) {
						                	return <option  key={t.id}  value={t.id} >{t.type_value} </option>;
						                })
						            }
						            </select>
						        </div>

								<div className="col-xs-12 col-sm-4">
									<span className="span-min">Centro Colecta</span>

									<select className="form-control input_data_donor" disabled={this.state.don_usr_clc.value === "NO"}
						             	value={ this.state.convoke_places_id || "" } onKeyPress={(e) => this.validateInput(e)}
							        	onChange={ this.handleChange } autoFocus={true} 
						              	name="convoke_places_id" id="convoke_places_id">
						              		<option value="">Seleccionar...</option>
						                {this.state.convoke_places.map(function(t, i) {
						                  return <option key={i}  value={t.convoke_places.id} >
						                  	{t.convoke_places.name} 
						                  </option>;
						                })}
					              	</select>
									  
						        </div>				        

						        <div className="col-xs-12 col-sm-2">
						        	<span className="span-min">{t('content.offers.form.extraction_type')}</span>
									<select className="form-control input_data_donor" onKeyPress={(e) => this.validateInput(e)}
										value={ this.state.donation_type_extraction_id || ""} 
							        	onChange={this.extractionTypeSelected}  
						              	name="donation_type_extraction_id" id="donation_type_extraction_id" >
						              	<option value="" disabled>Seleccionar...</option>
						                {
						                this.state.extraction_types.map(function(t) {
						                	return <option key={t.donation_type_extraction.id} value={t.donation_type_extraction.id} >{t.lookup_value}</option>;
						                })
						            }
						            </select>
						        </div>

						        <div className="col-xs-12 col-sm-2">
						        	<span className="span-min">{t('content.offers.form.donation_type')}</span>
									<select className="form-control input_data_donor" name="donation_type_id" id="donation_type_id" 
							        	value={ this.state.donation_type_id || ""} onKeyPress={(e) => this.validateInput(e)}
							        	onChange={this.donationTypeSelected} > 
							        	<option value="" disabled >Seleccionar...</option>
						                {
						                this.state.donation_types.map(function(t) {
						                	return <option key={t.donation_type.id} value={t.donation_type.id} >{t.donation_type_lookup}</option>;
						                })
						            }
						            </select>
						        </div>
						   	</div>
							<div className="col-xs-12">
								<div className="col-xs-7">
						 			<span className="span-min">{t('content.generics.buttons.search')}</span>
							        <AsyncTypeahead
							          /*{...this.state}*/
							          labelKey={(option) => `${option.names}`}
							          minLength={3}
							          maxLength={50}
							          name="patient"
							          id="patient"
							          onSearch={this._handleSearchDonor}
							          placeholder="Buscar por apellidos más nombre o número de documento..."
							          options={this.state.optionsDonor}
							          onChange={this.updateStateDonor}
							          ref="_handleSearchDonor"
							          useCache={false}
							          isLoading={this.state.isLoading}
							          delay={600}
							          paginationText="Mostrar mas resultados..."
							        />
							 			
								</div>

								<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
									<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
										onClick={this.person_search}/>
								</div>

						        <div className="col-xs-12 col-sm-4">
									
									<button style={{marginTop:"16px",marginLeft:"5px"}} 
										type="button" className="btn btn-info button-min" 
										onClick={(e)=>this.clearForm(e)}>
										LIMPIAR
									</button>
									
						        </div>
							</div>
							<div className="col-xs-12">
								{this.state.checkEditData?
									<div className="col-xs-12">
										<input className="form-check-input" type="checkbox" name="blockFields" onKeyPress={(e) => this.validateInput(e)}
								        		value={ this.state.blockFields} onChange={ this.availableEdit } style={{marginRight:'5px'}}/>
							        	<span className="span-min">Editar Datos</span>
								    </div>
								:null}
							</div>
							<div className="col-xs-12 col-sm-8" style={{padding:'0'}}>
								<div className="col-xs-12">
									<div className=" col-xs-12 col-sm-6" >
										<span className="span-min">{t('content.offers.form.names')}</span>
										<input className="form-control input_data_donor" id="names" name="names" disabled={this.state.blockFields}
											value={ this.state.names } onKeyPress={(e) => this.validateInput(e)} onChange={ this.handleChange } />
									</div>

									<div className="col-xs-12 col-sm-3">
							 			<span className="span-min">{t('content.offers.form.lastname1')}</span>
										<input id="lastname1"  className="form-control input_data_donor" name="lastname1" 
											value={ this.state.lastname1} onChange={ this.handleChange } 
											disabled={this.state.blockFields} onKeyPress={(e) => this.validateInput(e)}/>
									</div>
									<div className="col-xs-12 col-sm-3" >
							 			<span className="span-min">{t('content.offers.form.lastname2')}</span>
										<input className="form-control input_data_donor" name="lastname2" id="lastname2" value={ this.state.lastname2 } 
							 				onChange={ this.handleChange } disabled={this.state.blockFields} onKeyPress={(e) => this.validateInput(e)}/>
									</div>
								</div>

								<div className="col-xs-12">

									<div className="col-xs-12 col-sm-3" >
							 			<span className="span-min">{t('content.offers.form.document_type')}</span>
											
							            <select className="form-control input_data_donor" onKeyPress={(e) => this.validateInput(e)}
											name="document_type" id="document_type" disabled={this.state.blockFields}
									        value={ this.state.document_type || ""} 
									        onChange={ this.selectFieldHandle.bind(null,"id","document_type") }> 
									        <option value="" disabled>Seleccionar...</option>
							                {
								                this.state.documents.map(function(t) {
								                  return <option key={t.id}  value={t.key} >{t.name} </option>;
								                })
								            }
						                
						              	</select>
									</div>
									<div className="col-xs-12 col-sm-3" >
										<span className="span-min">{t('content.offers.form.number')}</span>
							        	<input disabled={this.state.blockFields} className="form-control input_data_donor" 
											name="document_number" id="document_number" value={ this.state.document_number || "" } 
								            onChange={ this.handleChange } onKeyPress={(e) => this.validateInput(e)} />
									</div>
									<div className="form-group col-xs-12 col-sm-2" style={{marginBottom: 0}}>
										<span className="span-min">{t('content.offers.form.birthday')}</span>
										<MaskedFormControl type='text' name="birthday" id="birthday" 
												value={this.state.birthday} disabled={this.state.blockFields}
		                      					onChange={this.dateHandleChange} onKeyDown={(e) => this.validateInput(e)}
		                      					mask='11/11/1111' placeholder="dd/mm/yyyy" className="form-control input_data_donor input-date"/>
									</div>
									<div className="form-group col-xs-12 col-sm-1" style={{marginBottom: 0}}>
										<span className="span-min">{t('content.offers.form.age')}</span>
										<input className="form-control" name="age" value={ this.state.age } 
							 				onChange={ this.handleChange } onKeyPress={(e) => this.validateInput(e)} disabled/>
									</div>
									<div className="col-xs-12 col-md-3" >
										<span className="span-min">{t('content.modal_hc.sex')}</span>
										<select className="form-control input_data_donor" id="sex" name="sex" 
											value={ this.state.sex } onChange={ this.handleChange } 
											disabled={this.state.blockFields}
											onKeyPress={(e) => this.validateInput(e)} > 
									        <option value="" disabled>Seleccionar...</option>
							                {
								                genders.map(function(t) {
								                  return <option key={t}  value={t} >{t} </option>;
								                })
								            }
						              	</select> 
									</div>
								</div>
								<div className="col-xs-12 col-sm-9" style={{paddingRight:"0px"}}>
									<AddressData 
										state={this.state} 
										validate={this.validateInput}
										handleChange={this.handleChange} 
										selectFieldHandle={this.selectFieldHandle} 
										autocompleteHandle={this.autocompleteHandle}
										onRef={ref => (this.address = ref)}/>

									
				        		</div>
							</div>
							<div className="col-xs-12 col-sm-3" style={{padding:"0px"}}>
			        			<PhonesData 
									disableElement={false} 
									phonesAdded={this.state.phonesAdded} 
									submenu={this.props.location.pathname}
									state={this.state} 
									handleChange={this.handleChange} 
									selectFieldHandle={this.selectFieldHandle} 
									addPhoneToList={this.addPhoneToList} 
									removePhoneFromList={this.removePhoneFromList}/>
			        		</div>

							{/*termina segunda linea*/}
							
			        		
						</fieldset> 

						{/*DATOS DEL PACIENTE EN CASO DE QUE SEAN REQUERIDOS*/}
						{this.state.show_patient_data?
							<div className="col-xs-12">
								<PatientData setState={this.setState} 
									validate={this.validateInput}
									state={this.state} 
									onRef={ref => (this.patient = ref)}
									handleChange={this.handleChange} 
									selectFieldHandle={this.selectFieldHandle} 
									setInfoPatient={this.setInfoPatient}
									setInfoDonor={this.setInfoDonor}
									autocompleteHandle={this.autocompleteHandle}
									waiting={this.props.waiting}
									dateHandleChange={this.dateHandleChange}
									clearPatientSearch = {this.clearPatientSearch}/>
							</div>:null
						}
						
						<fieldset className="col-xs-12" style={{padding:"0"}}>
							<legend style={{marginBottom:"5px"}}>Datos Donación</legend>
							
							<div className="col-xs-12">
								<div className="col-xs-9 col-sm-10 col-md-2">
									<label className="span-min">{t('content.extractions.form.donation_number')}</label>
									<input className="form-control bio_extraction" style={{padding:"3px",margin:"0px", fontSize:"16px"}} 
										name="donation_number" id="donation_number" required disabled 
										value={ this.state.show_num_donation ? this.state.donation_number : "" } />
								</div>

								<div className="col-xs-1 col-sm-1 col-md-1">
									<Button className="btn btn-info btn-xs" style={{marginTop:"21px"}} type="button" 
										title="Generar Número de Donación" onClick={this.onClickDownload} disabled={this.state.show_num_donation} >
										<SvgIcon icon={download}  style={{paddingTop:"3px"}}/>
									</Button>
								</div>
							</div>
							<div className="col-xs-12">
								{/*FECHA & HORA DE LA EXTRACCIÓN*/} 
								<div className="col-xs-12 col-sm-2" style={{padding:"0px"}}>
									<div className="col-xs-12">
										<span className="span-min">{t('content.extractions.form.date_extraction')}</span>
									</div>
									<div className="col-xs-6">
										<MaskedFormControl type="text" name="date_extraction_date" 
											className="input-date"
											value={this.state.timestamp_date} id="date_extraction_date" 
											mask='11/11/1111' onBlur={this.onDateChange}
											placeholder="dd/mm/yyyy" style={{padding:"5px"}}
											disabled={this.state.disabled_element} />
									</div>
									<div className="col-xs-6" style={{paddingRight:"0px"}}>
										<input type="text" id="date_extraction_hour" name="date_extraction_hour"  
											data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
											data-inputmask-placeholder="-" value={this.state.timestamp_hour || ""} 
											onChange={this.onHourChange} onBlur={this.onHourChange}
											style={{padding:"5px"}} disabled={this.state.disabled_element}
											className="form-control" onKeyPress={(e) => this.validateInput(e)}/>
									</div>
								</div>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">No. Externo</span>
									<input type="number" step="0.01" className="form-control volume-unit bio_extraction" 
										name="local_number" id="local_number" value={ this.state.local_number || ""} 
										onChange={ this.handleChange } disabled={this.state.disabled_element} 
										onKeyPress={(e) => this.validateInput(e)}/>
								</div>
								{/*CAMPOS REQUERIDOS PARA TIPO DE EXTRACCION SANGRE TOTAL*/}
								{this.state.type_extraction_name == "SANGRE_TOTAL"?
									<div className="col-xs-6" style={{padding:"0px"}}>
										<div className="col-xs-12 col-sm-4" >
											<span className="span-min">{t('content.extractions.st.blood_bags_id')}</span>
											<select className="form-control bio_extraction" value={ this.state.donation.blood_bags_id || ""} 
												onChange={ this.onElementDonationSelected.bind(this) } name="blood_bags_id" 
												id="blood_bags_id" disabled={this.state.disabled_element}
												onKeyPress={(e) => this.validateInput(e)} required>
												<option value="" disabled>Seleccionar...</option>
												{
													this.state.blood_bags.map(function(t) {
														return <option key={t.blood_bag.id} value={t.blood_bag.id} >{t.blood_bag.name}</option>;
													})
												}
											</select>
										</div>

										<div className="col-xs-12 col-sm-2">
											<span className="span-min">{t('content.extractions.st.duration')}</span>
											<input type="number" step="0.01" className="form-control volume-unit bio_extraction" 
												name="extraction_time" id="extraction_time" 
												value={ this.state.extraction_time} onChange={ this.handleChange } 
												min="0" required
												disabled={this.state.disabled_element} onKeyPress={(e) => this.validateInput(e)}/>
										</div>
										<div className="col-xs-12 col-sm-2">
											<span className="span-min">{t('content.extractions.st.volume')}</span>
											<input className="form-control volume-unit bio_extraction" name="volume" id="volume" required
												value={ this.state.volume  } onChange={ this.handleChange } type="number"
												min="0"
												disabled={this.state.disabled_element} onKeyPress={(e) => this.validateInput(e)}/>
										</div>
										<div className="col-xs-12 col-sm-4" style={{padding:"0px"}}>
											<span className="span-min">Grupo y RH</span>
											<select className="form-control bio_extraction" name="group_rh" id="group_rh"
												value={this.state.group_rh} onKeyPress={(e)=>this.validateInput(e)}
												disabled={this.state.disabled_element} onChange={this.handleChange}>
												<option value="">Seleccione...</option>
												{this.state.blood_group.map((group, i)=>{
													return <option key={i} value={group.key_group+' '+group.key_rh}>
														{group.name}
													</option>
												})}
											</select>
										</div>
									</div>
								:this.state.type_extraction_name === "AFÉRESIS"?
									/*EL TIPO DE EXTRACCION ES AFÉRESIS*/
									<div className="col-xs-12" style={{padding:"0px"}}>
										<div className="col-xs-12" style={{padding:"0px"}}>
											<div className="col-xs-12 col-sm-2">
									        	<span className="span-min">{t('content.extractions.apheresis.apheresis_kits_id')}</span>
												<select className="form-control bio_extraction" value={ this.state.apheresis_kits_id || ""} 
										        	onChange={ this.handleChange.bind(this) } name="apheresis_kits_id" 
										        	id="apheresis_kits_id" disabled={this.state.disabled_element} required
										        	onKeyPress={(e) => this.validateInput(e)}>
									              	<option value="" disabled>Seleccionar...</option>
									                {
									                	this.state.apheresis.map(function(t){
									                		return <option key={t.apheresis_kit.id} value={t.apheresis_kit.id} >{t.apheresis_kit.name}</option>;
									                	})
									                }
									            </select>
									        </div>
									        <div className="col-xs-12 col-sm-2" style={{padding:"0px"}}>
												<span className="span-min">Grupo y RH</span>
												<select className="form-control bio_extraction" name="group_rh" id="group_rh" 
													value={this.state.group_rh} onKeyPress={(e)=>this.validateInput(e)}
													disabled={this.state.disabled_element} onChange={this.handleChange}>
													<option value="">Seleccione...</option>
													{this.state.blood_group.map((group, i)=>{
														return <option key={i} value={group.key_group+' '+group.key_rh}>
															{group.name}
														</option>
													})}
												</select>
											</div>
									    </div>

									    <div className="col-xs-12" style={{padding:"0px"}}>
									    	<div className="col-sm-6">
									    		<div className="col-xs-12 col-sm-6">
									    		
										    	</div>
										    	{this.state.apheresis_kits_id!==""?
										    		<div className="col-xs-12 col-sm-3" style={{textAlign:"center"}}>
											    		<span className="span-min">Bolsa 1</span>
											    	</div>
											    :null}
										    	{this.state.double ?
										    		<div className="col-xs-12 col-sm-3" style={{textAlign:"center"}} >
											    		<span className="span-min">Bolsa 2</span>						    		
											    	</div>
											    :null
										    	}
											    	
									    	</div>
									    </div>

									    <div className="col-xs-12" style={{padding:"0px"}}>
									    	<div className="col-sm-6 form-group">
									        	{this.state.component_kit.length > 0 ?
									        		this.state.component_kit.map((c, i)=>{	
											        	return c.component !== undefined ?
										        			<div className="col-xs-12 " key={c.id}>
												        		<div className="col-xs-6" style={{padding:"5px 0 0 0"}}>
												        			<span className="span-min">{c.component}</span>
												        		</div>
											        			{this.state.unit[i] !== undefined ?
											        				this.state.unit[i].length > 0 ?
																		this.state.unit[i].map((u, j)=>{
												        					return this.state.double ?
												        						<div key={j} className="col-xs-2" style={{padding:"5px 0 0 12px"}}> 
													        						<input id={'vol_'+this.state.asigned_kit[i].blood_component_id+'_'+u.unit}  
													        							className="form-control volume-unit bio_extraction" type="number"
																						name={'vol_'+this.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																						value={u.volume || ""} //onKeyPress={(e) => this.props.validate(e)}
																						onKeyPress={this.keyPressed} disabled={this.state.disabled_element}
																						onChange={this.onVolumeChange} required
																						placeholder={t('content.extractions.components_kit.volumen')} />
													        					</div>
												        					: j === 0 ?
												        						<div key={j} className="col-xs-2" style={{padding:"5px 0 0 12px"}}> 
													        						<input id={'vol_'+this.state.asigned_kit[i].blood_component_id+'_'+u.unit}  
													        							className="form-control volume-unit bio_extraction" type="number"
																						value={u.volume || ""} //onKeyPress={(e) => this.validateInput(e)}
																						name={'vol_'+this.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																						onKeyPress={this.keyPressed} disabled={this.state.disabled_element}
																						onChange={this.onVolumeChange} required
																						placeholder={t('content.extractions.components_kit.volumen')} />
													        					</div>
												        					:null
												        				})
											        				:null
												        			
											        			:null}
												        	</div>
										        		: null
											
									        		})
									        		: null
									    		}
									        </div>
									    </div>
									</div>
								:null}
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-2" style={{padding:"0px"}}>
										<span className="span-min">Fecha y Hora Registro</span>
										<input className="form-control" name="created_at" id="created_at" required
										value={ this.state.timestamp || "" } onChange={ this.handleChange } type="text" disabled />
									</div>
								</div>
							</div>
							
						</fieldset> 
						
						
						
						<fieldset className="col-xs-12" style={{padding:"0"}}>
	        				<legend>Biometría Hemática</legend>
	        				<div className="col-xs-12">
		        				<List>
		        				{
									this.state.biometrics.map( (t, index) => (
										<div className="col-xs-12 col-sm-3 col-md-1" style={{padding:"2px 2px 2px 8px",overflow:"hidden"}} key={index}>
											<span className="size-min" style={{whiteSpace:"nowrap"}}>{t.name}</span>
										
											<input 
												disabled={this.state.disabled_element ? true :
													t.data_type === "BIO_D_CALCULATED" || 
													(!this.props.task_biometrics.create && !this.props.task_biometrics.update)||
													this.state.exist_extraction
												} 
												className="form-control bio_extraction" name={'biometric_'+t.id.toString()} 
												step="0.01" type="number" min="0" 
												maxLength="4"
												id={'biometric_'+t.id.toString()}
												onChange={(e) => this.calculateValuesBIO(e)}
												onKeyPress={(e) => this.validateInput(e)}
												 />
										</div>
									))
								}
			        			</List>
		        			</div>
	        			</fieldset>
        				
        				
					</div>
				</form>

				<div style={{paddingTop:"10px",textAlign:"center"}}>
    				<button className="toolIcon" disabled={this.state.disableBar} onClick={this.onLabelClick}>
						<SvgIcon size={40} icon={ic_local_offer} />
						<div className="col-xs-12" style={{padding:"0px"}}>
							<span>{t('toolbar.labels')}</span>
						</div>
					</button>
				</div>

				<div className="col-xs-12" style={{textAlign:'center'}}>
		        	<div>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave}  style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onCancel}/>
		        	</div>
		        </div>
				
				<Notifications />
				<ModalGrupoRH {...this.props} onRef={ref => (this.modal_grupo_rh = ref)} updateGroupTestData={this.updateGroupTestData}/>
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)} />
				<ModalPersonSearch {...this.props} updatePerson={this.updateStateDonor} onRef={ref => (this.modal_person_search = ref)} />
			</div>
		)
	}
}

export default translate('translations')(BagEntries);